// Where a sign-in or invitation link lands when it does not open the app.
//
// The app claims this path as a Universal Link, so on a phone that has it
// installed nobody ever sees this page — iOS opens The Stable directly and the
// browser is never involved. This is the other branch: a laptop, a mail client
// that strips the association, a parent who has not installed the app yet.
//
// It deliberately does not try to open the app by itself on load. Redirecting
// to a custom scheme that nothing handles puts up "Safari cannot open the page"
// in front of a parent who did nothing wrong, and the people who get here are
// disproportionately the ones without the app. So the hand-off is a button they
// choose to press, and the code from the same email is right there underneath
// for everyone else.
//
// The token is never sent anywhere from this page. It goes to the app, and the
// app exchanges it. A page that signed people in itself would need a session in
// a browser nobody is going to use.

const APP_LINK = (token) => `l2bstable://parent/auth?token=${encodeURIComponent(token)}`;

export default function SignInLink() {
  const token = new URLSearchParams(window.location.search).get('token') || '';

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#221420] px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#ee8a1e]">
          Learn2Bhangra
        </div>
        <h1 className="mt-3 text-3xl font-bold text-[#f7f1e6]">Open The Stable</h1>

        {token ? (
          <>
            <p className="mt-3 text-[#f7f1e6]/60">
              Your sign-in is ready. Open the app to finish.
            </p>

            <a
              href={APP_LINK(token)}
              className="mt-7 inline-block rounded-xl bg-[#ee8a1e] px-7 py-3.5 text-base font-bold text-[#221420]"
            >
              Open the app
            </a>

            <p className="mt-8 border-t border-[#443040] pt-6 text-sm leading-relaxed text-[#f7f1e6]/55">
              Nothing happening? You are probably reading this somewhere the app
              isn&rsquo;t installed — on a computer, say. Open The Stable on your
              phone and type the six-character code from the same email. It does
              exactly the same thing.
            </p>
          </>
        ) : (
          <p className="mt-3 text-[#f7f1e6]/60">
            This link is missing its sign-in code. Open The Stable on your phone
            and ask for a new one.
          </p>
        )}
      </div>
    </div>
  );
}
